import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import Company from '@/components/pages/Company'
import Products from '@/components/pages/Products'
import Product from '@/components/pages/Product'
import Contact from '@/components/pages/Contact'
import Privacy from '@/components/pages/Privacy'
import Faq from '@/components/pages/Faq'
import News from '@/components/pages/News'
import Guide from '@/components/pages/Guide'
import Choice from '@/components/pages/Choice'
import Tradelaw from '@/components/pages/Tradelaw'
import Rental from '@/components/pages/Rental'
import Columns from '@/components/pages/Columns'
import Column from '@/components/pages/Column'
import Industry from '@/components/pages/Industry'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/company',
    name: 'Company',
    component: Company,
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
  },
  {
    path: '/product/:name/:type',
    name: 'ProductType',
    component: Product,
    beforeEnter: (to, _, next) => {
      if (to.params.type !== 'feature') {
        next({
          path: `/product/${to.params.name}/feature`,
          hash: `#${to.params.type}`,
        })
      } else {
        next()
      }
    },
    pathToRegexpOptions: { strict: true },
  },
  {
    path: '/product/:name',
    name: 'ProductTop',
    component: Product,
    pathToRegexpOptions: { strict: true },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq,
  },
  {
    path: '/news',
    name: 'News',
    component: News,
  },
  {
    path: '/guide',
    name: 'Guide',
    component: Guide,
  },
  {
    path: '/choice',
    name: 'Choices',
    component: Choice,
  },
  {
    path: '/choice/:type',
    name: 'Choice',
    component: Choice,
  },
  {
    path: '/tradelaw',
    name: 'Tradelaw',
    component: Tradelaw,
  },
  {
    path: '/rental',
    name: 'Rental',
    component: Rental,
  },
  {
    path: '/columns',
    name: 'Columns',
    component: Columns,
  },
  {
    path: '/column/24',
    redirect: '/choice/industry/1',
  },
  {
    path: '/column/13',
    redirect: '/choice/industry/2',
  },
  {
    path: '/column/14',
    redirect: '/choice/industry/3',
  },
  {
    path: '/column/15',
    redirect: '/choice/industry/4',
  },
  {
    path: '/column/17',
    redirect: '/choice/industry/5',
  },
  {
    path: '/column/19',
    redirect: '/choice/industry/6',
  },
  {
    path: '/column/18',
    redirect: '/choice/industry/7',
  },
  {
    path: '/column/16',
    redirect: '/choice/industry/8',
  },
  {
    path: '/column/21',
    redirect: '/choice/industry/9',
  },
  {
    path: '/column/23',
    redirect: '/choice/industry/10',
  },
  {
    path: '/column/20',
    redirect: '/choice/industry/11',
  },
  {
    path: '/column/22',
    redirect: '/choice/industry/12',
  },
  {
    path: '/column/:no',
    name: 'Column',
    component: Column,
    pathToRegexpOptions: { strict: true },
  },
  {
    path: '/choice/industry/:no',
    name: 'Industry',
    component: Industry,
    pathToRegexpOptions: { strict: true },
  },
]

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    const position = {}
    if (to.hash) {
      position.selector = to.hash
    } else {
      position.x = 0
      position.y = 0
    }
    return position
  }
}

export default new Router({
  mode: 'history',
  base: process.env.ROOT_BASE,
  routes,
  scrollBehavior,
})



// WEBPACK FOOTER //
// ./src/router/index.js